import React, { createContext, useContext, useState } from 'react';

type Filters = {
  sent?: boolean;
  typeSent?: 'sms' | 'email';
  checked?: boolean;
};

type FiltersContextType = {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
};

const FiltersContext = createContext<FiltersContextType | undefined>(undefined);

export const FiltersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [filters, setFilters] = useState<Filters>({
    sent: undefined,
    typeSent: undefined,
    checked: undefined,
  });

  return <FiltersContext.Provider value={{ filters, setFilters }}>{children}</FiltersContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useFilters = () => {
  const context = useContext(FiltersContext);

  if (context === undefined) {
    throw new Error('Ошибка при создание контекста');
  }

  return context;
};
